import { message } from "antd";
import {
  deleteCommunicationBinding,
  putCommunicationBinding,
} from "../service";
import { ASSISTANT } from "../Assistant";

const phoneNumbermessages = {
  loadingAdd: "Adding phone number",
  successAdd: "Phone number added",
  failureAdd: "Failed to add phone number",
  loadingRemove: "Removing phone number",
  successRemove: "Phone number removed",
  failureRemove: "Failed to remove phone number",
};

const pageIdMessages = {
  loadingAdd: "Adding Page",
  successAdd: "Page added",
  failureAdd: "Failed to add page",
  loadingRemove: "Removing page",
  successRemove: "Page removed",
  failureRemove: "Failed to remove page",
};

const emailAddressMessages = {
  loadingAdd: "Adding Email",
  successAdd: "Email added",
  failureAdd: "Failed to add email",
  loadingRemove: "Removing Email",
  successRemove: "Email removed",
  failureRemove: "Failed to remove email",
};

const assistantMessages = {
  voice: phoneNumbermessages,
  whatsapp: phoneNumbermessages,
  sms: phoneNumbermessages,
  messenger: pageIdMessages,
  instagram: pageIdMessages,
  email: emailAddressMessages,
};

function useCommunicationBinding({
  syncAssistant,
  assistantId,
  workspaceId,
  assistantType,
}) {
  const addCommunicationBinding = async (payload) => {
    const { loadingAdd, successAdd, failureAdd } =
      assistantMessages[assistantType];
    message.loading(loadingAdd);
    try {
      const response = await putCommunicationBinding({
        workspaceId,
        assistantId,
        payload,
      });
      if (response.status === 201) {
        message.destroy();
        message.success(successAdd);
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            communicationBinding: [
              ...prevAssistant.communicationBinding,
              response.data.binding,
            ],
          };
        });
        return;
      }
    } catch (e) {
      message.destroy();
      message.error(
        e.response.data?.message || e.response.data?.msg || failureAdd
      );
      console.error("Error in updating communication binding");
    }
  };

  const removeCommunicationBinding = async (communicationBindingId) => {
    const { loadingRemove, successRemove, failureRemove } =
      assistantMessages[assistantType];
    message.loading(loadingRemove);
    try {
      const response = await deleteCommunicationBinding({
        workspaceId,
        assistantId,
        communicationBindingId,
      });
      if (response.status === 200) {
        message.destroy();
        message.success(successRemove);
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            communicationBinding: response.data.communicationBinding,
          };
        });
        return;
      }
    } catch (e) {
      message.destroy();
      message.error(
        e.response.data?.msg ||
          e.response.data?.message ||
          e.response.data?.error ||
          failureRemove
      );
      console.error("Error deleting communication binding");
    }
  };

  return { addCommunicationBinding, removeCommunicationBinding };
}

export { useCommunicationBinding };
